@if(loader.getLoading()) {
  <div class="container">
    <div class="speeding-wheel"></div>
    <div class="comment">{{loader.target}}</div>
  </div>
}
